import { render, staticRenderFns } from "./userPortrait.vue?vue&type=template&id=f35eab9e&scoped=true&"
import script from "./userPortrait.vue?vue&type=script&lang=js&"
export * from "./userPortrait.vue?vue&type=script&lang=js&"
import style0 from "./userPortrait.vue?vue&type=style&index=0&id=f35eab9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35eab9e",
  null
  
)

export default component.exports